// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__+eE5R","actions":"style_actions__3a9G6","actions_btn":"style_actions_btn__fpyo1"};